import React, { useEffect, useState } from 'react'
import { approvePurchaseOrderApi, getPurchaseOrderApi } from '../../utils/ApiEndpointFunctions';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { MONTHS } from '../../utils/constant';
import Spinwheel from '../../components/common/Spinwheel';
import { useUserContext } from '../../context/userContext';
import toast from 'react-hot-toast';
import ConfirmationModal from '../../components/modal/ConfirmationModal';
import Filter from '../../components/modal/Filter';
import { useFormik } from 'formik';
import moment from 'moment/moment';
import ReactPaginate from 'react-paginate';
import { formatPrice, getLocalizationStatus } from '../../utils/HelperFuncitons';
import StatusModal from '../../components/modal/StatusModal';

export default function PurchaseTable(props) {
  const [po, setPo] = useState([])
  const [loading, setLoading] = useState({ po: true })
  const navigate = useNavigate();
  const { userDetails,langPreference } = useUserContext();
  const confirmModalId = "conFirmModalID"
  const filterModalId = "filterModalID"
  const statusModalId = "statusModal"
  const [selectPO, setSelectPO] = useState({id:null,poNo:null});
  const limit = 10;
  const [page, setPage] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [confirmMessage, setConfirmMessage] = useState("");
  // let [selectedPage, setSelectedPage] = useState(searchParams.get("page") == null ? 1 : searchParams.get("page"));
  const location = useLocation()

  const [totalCount, setTotalCount] = useState(null);

  const getPurchaseOrders = async (filterReset) => {
    console.log("filterFormik",filterFormik?.values);
    
    setLoading({ ...loading, po: true });
    let filter = filterReset === "reset" ? ["", "", "", "", "", ""] : [
      filterFormik.values?.uniqueItemId,
      `${filterFormik.values?.to ? new Date(filterFormik.values?.to).getTime() + "-" : ""}${filterFormik.values?.from ? new Date(filterFormik.values?.from).getTime() : ""}`,
      filterFormik.values?.hsnCode,
      filterFormik.values?.number,
      filterFormik.values?.status,
      filterFormik.values?.vendorId,
    ];
    try {
      const page = searchParams.get("page") || 1
      const res = await getPurchaseOrderApi(...filter, limit, page);
      if (res.status === 200) {
        setPo(res.data?.data?.purchaseOrders);
        setTotalCount(res.data?.data?.totalCount);
        setPage(Math.ceil(res.data?.data?.totalCount / limit));
      }
    } catch (error) {
      console.log(error)
    }
    setLoading({ ...loading, po: false });
  }

  const handlePageClick = (event) => {
    let currentPage = event.selected + 1;

    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", currentPage);

    if (newParams.has("tab")) {
      newParams.set("tab", newParams.get("tab"));
    }

    setSearchParams(newParams);
  };


  const handlePoApproval = async () => {
    try {
      const res = await approvePurchaseOrderApi({ id: selectPO.id })
      if (res.status === 200) {
        toast.success(res.data?.message)
        setConfirmMessage(res.data?.message || `Purchase Order ${res?.data?.data} is successfully approved.`)
        document.getElementById(confirmModalId).click()
        document.getElementById("statusModalBtn").click()
        getPurchaseOrders()
      }
    } catch (error) {
      console.log(error)
      toast.error("something went wrong");
    }
  }

  const calculateAmount = (ele) => {
    let amount = 0;
    ele.forEach((item) => {
      amount += (item.quantity * item.unitPrice) * ((100 + item.itemDetails.tax) / 100)
    })
    return amount
  }

  const handleFilterPo = () => {
    if (searchParams.get('page') == 1) {
      getPurchaseOrders()
    } else {
      setSearchParams({ "page": 1 })
    }
  }

  const filterFormik = useFormik({
    initialValues: {
      type:"Vendor",
      Item: "",
      hsnCode: "",
      number: "",
      status: "",
      uniqueItemId:"",
      vendorName: "",
      to: "",
      from: "",
      itemId:""
    }
  })

  // useEffect(() => {
  //   getPurchaseOrders()
  // }, [])

  useEffect(() => {
      getPurchaseOrders()
  },[searchParams.get('page')])


  return (
    <>

      <div className="main-content">
        <div className="container-fluid">
          <div className="row">
            <div className="main-content">

              {props.type !== "dashboard" && <div className="dash-nav1">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="mb-0 font-blue">{langPreference?.purchase_order || "Purchase Order"}</h3>
                  {userDetails?.roleId?.permission?.includes("poWrite") && <button onClick={() => { navigate("/purchase/add"); }} className="create-order mb-3">{langPreference?.create_po || "Create Purchase Order"}</button>}
                </div>
              </div>}
              <div className="d-flex justify-content-end align-items-end">
                <div className="d-flex align-items-center justify-content-end">
                  <div className="dropdown">
                    <button className="btn btn-dark me-2" type="button" disabled={!Object.values(filterFormik?.values).filter(Boolean).length} onClick={() => { filterFormik.resetForm(); getPurchaseOrders("reset") }} >
                    {langPreference?.reset_filter || "Reset filter"}
                    </button>
                    <button className="btn filter  dropdown-toggle" type="button" data-bs-toggle="modal" data-bs-target={`#${filterModalId}`}  >
                      <i className="bi bi-funnel me-2"></i>{langPreference?.filter || "Filter"}
                    </button>
                  </div>
                  {/* <nav className="navbar bg-body-tertiary">
                          <form role="search" className="container-fluid">
                            <div className="input-group">
                              <span className="input-group-text" id="basic-addon1"><i className="bi bi-search"></i></span>
                              <input type="text" className="form-control" placeholder="Search po number" aria-label="Username" aria-describedby="basic-addon1" />
                            </div>
                          </form>
                        </nav> */}
                  {/* <!-- <form >
                                   <input className="form-control" type="search" placeholder="" aria-label="Search">
                               </form> --> */}
                </div>
              </div>
              {/* <!-- table --> */}
              <div className="table-responsive" style={{ overflowX: "inherit" }}>
                <table className="table d-table mt-4">
                  <thead>
                    <tr>
                      <th scope="col">{langPreference?.po_number || "PO NUMBER"}</th>
                      <th scope="col">{langPreference?.item_counts || "ITEMS COUNT."}</th>
                      <th scope="col">{langPreference?.amount || "AMOUNT"}</th>
                      <th scope="col">{langPreference?.vendor_name || "VENDOR NAME"}</th>
                      <th scope="col">{langPreference?.gst_number || "GST NUMBER"}</th>
                      <th scope="col">{langPreference?.created_date || "CREATED DATE"}</th>
                      <th scope="col">{langPreference?.due_date || "DUE DATE"}</th>
                      <th scope="col">{langPreference?.status || "STATUS"}</th>
                      <th scope="col">{langPreference?.action || "ACTION"}</th>
                    </tr>
                  </thead>
                  {
                    loading.po ?
                      <tbody >
                        <tr>
                          <td colSpan={12}>
                            <div className="d-flex justify-content-center">
                              <Spinwheel />
                            </div>
                          </td>
                        </tr>
                      </tbody> :
                     
                        <tbody>
                          {po?.length > 0 ? po?.map((ele, index) => {
                            return (
                              <tr key={index}>
                                <td>{ele?.poNumber}</td>
                                <td>{ele?.items?.length}</td>
                                <td>{formatPrice(ele?.amount)}</td>
                                <td>{ele?.vendor?.name}</td>
                                <td>{ele?.vendor?.gstNumber}</td>
                                <td>{moment(ele?.createDate).format("DD/MM/YYYY")}</td>
                                <td>{moment(ele?.dueDate).format("DD/MM/YYYY")}</td>
                                <td><button className={` cursor-text text-capitalize ${ele?.status?.toLowerCase() == "approved" ? "approve" : (ele?.status?.toLowerCase() == "reject" ? "reject" : "sbm")} `}>{getLocalizationStatus(langPreference,ele?.status+(ele?.externalStatus ? "("+ele?.externalStatus+")" :""))}</button></td>
                                <td>
                                  <div className="d-flex justify-content-start align-items-center">
                                    <div>
                                      {/* <>
                                      {ele?.status?.toLowerCase() === "submitted" ? <>
                                        {userDetails?.roleId?.permission.includes("poRead") && <button className="view" onClick={() => { navigate(`/purchase/view/${ele?._id}`) }}>View</button>}
                                      </> : <button className="apr">Approve</button>}</> */}
                                      {userDetails?.roleId?.permission.includes("poReject") && ele?.status?.toLowerCase() !== "reject" && <button className="reject">Reject</button>}
                                    </div>
                                    <div>
                                      <div className="dropdown">
                                        <button className="dots dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-three-dots-vertical"></i></button>
                                        <ul className="dropdown-menu">
                                          {userDetails?.roleId?.permission.includes("poRead") && <li className='dropdown-item' onClick={() => { navigate(`/purchase/view/${ele?._id}`) }} >{langPreference?.view || "View"}</li>}
                                          {(((userDetails?.roleId?.permission.includes("poUpdate")) && ele?.status?.toLowerCase() != "approved")) && <li className='dropdown-item' onClick={() => { navigate(`/purchase/update/${ele?._id}`) }} >{langPreference?.edit || "Edit"}</li>}
                                          {userDetails?.roleId?.permission.includes("poApprove") && ele?.status?.toLowerCase() != "approved" &&
                                            <li className='dropdown-item' data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`} onClick={() => { setSelectPO({id:ele?._id,poNo:ele?.poNumber}) }} >{langPreference?.approve || "Approve"}</li>}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>)
                          }) : <tr className='text-center'>
                            <td colSpan="12">
                              <h1>{langPreference?.data_not_found || "Data Not Found"}</h1>
                            </td>
                          </tr>}
                        </tbody>}
                </table>
              </div>
              {totalCount > limit ? (
                <div className="d-flex justify-content-center">
                  <ReactPaginate
                    nextLabel={`${langPreference?.next_page || "Next"} >`}
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    pageCount={page}
                    previousLabel={`< ${langPreference?.previous_page || "Previous"}>`}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName={"active"}
                    forcePage={searchParams.get('page')? Number(searchParams.get('page'))-1 : 0}
                  />
                </div>
              ) : (
                ""
              )}
              <ConfirmationModal modalId={confirmModalId} handleConfirm={handlePoApproval} message={langPreference?.approve_confirmation || <>Are you sure you want to <br /> Approve ?</>} />
              <Filter modalId={filterModalId} formik={filterFormik} clickHandler={handleFilterPo} isSiteItem={true} filterType={"po"}/>
              <button className='d-none' id="statusModalBtn" data-bs-toggle="modal" data-bs-target={`#${statusModalId}`}/>
              <StatusModal 
                modalId={statusModalId}
                message={confirmMessage}
              />

            </div>
          </div>
        </div>
      </div>
    </>
  )
}
